import React from 'react';
import { Box, Skeleton } from '@mui/material';
import stylesProjectPage from '../../styles/projectPage/index.module.scss';

const ProjectCardSkeleton = () => {
  return (
    <Box className={`${stylesProjectPage.card} ${stylesProjectPage['skeleton-card']}`}>
      <Box className={stylesProjectPage.cardWrapper}>
        <Box className={stylesProjectPage.iconContainer}>
          <Skeleton 
            variant="circular" 
            className={stylesProjectPage['skeleton-icon']}
          />
          <Skeleton 
            variant="circular" 
            className={stylesProjectPage['skeleton-icon']}
          />
        </Box>

        <Box className={stylesProjectPage.cardContent}>
          <Skeleton
            variant="circular"
            className={`icon-xl ${stylesProjectPage['skeleton-icon-main']}`}
          />
          <Skeleton
            variant="text"
            width="70%"
            height={21}
            className={stylesProjectPage['skeleton-text-primary']}
          />
          <Skeleton
            variant="text"
            width="90%"
            height={21}
          />
        </Box>

        <Box className={stylesProjectPage.createdDisplay}>
          <Skeleton
            variant="text"
            width={80}
            height={18}
          />
        </Box>
      </Box>
    </Box>
  );
};

// Project Grid Skeleton Component
const ProjectGridSkeleton = ({ skeletonCount = 15 }) => {
  return (
    <Box className={stylesProjectPage['card-container']}>
      {Array.from({ length: skeletonCount }, (_, index) => (
        <Box key={`skeleton-${index}`}>
          <ProjectCardSkeleton />
        </Box>
      ))}
    </Box>
  );
};

export default ProjectGridSkeleton;
